import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["multiple", "accept", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(_ctx.rootClasses)
  }, [
    (!_ctx.dragDrop)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.draggableClasses),
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateDragDropFocus(true))),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateDragDropFocus(false))),
          onDragover: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateDragDropFocus(true)), ["prevent"])),
          onDragleave: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.updateDragDropFocus(false)), ["prevent"])),
          onDragenter: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.updateDragDropFocus(true)), ["prevent"])),
          onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)), ["prevent"]))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 34)),
    _createElementVNode("input", _mergeProps({
      ref: "input",
      type: "file"
    }, _ctx.$attrs, {
      multiple: _ctx.multiple,
      accept: _ctx.accept,
      disabled: _ctx.disabled,
      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
    }), null, 16, _hoisted_1)
  ], 2))
}